import { TallValidationType } from '../../types/generated-types';

export const getFeilmeldingForTallValideringType = (tallvalidering: TallValidationType) => {
    switch (tallvalidering) {
        case TallValidationType.Hel:
            return 'Du må oppgi et gyldig tall, uten desimaler.';
        case TallValidationType.Halv:
            return 'Du må oppgi et gyldig tall, rundet opp til nærmeste halvtime.';
        default:
            return 'Du må oppgi et gyldig tall.';
    }
};

export const getTallValideringsTypeFrom = (tallvalideringsType: string) => {
    switch (tallvalideringsType) {
        case 'Halv':
            return TallValidationType.Halv;
        case 'Hel':
            return TallValidationType.Hel;
        default:
            return TallValidationType.Udefinert;
    }
};

export const isValidTallHalv = (tall: number): boolean => {
    return tall > 0 && (tall / 0.5) % 1 === 0;
};

export const isValidTallHel = (tall: number): boolean => {
    return tall >= 0 && tall % 1 === 0;
};
